import {useTranslation} from 'react-i18next';
import {IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';
import {useFetchIVLottie} from '../../hooks';
import {ModalProps} from '@guestapp/old-ui-kit';
import notIncludedIcon from '../../assets/icons/not-included-icon.svg?no-inline';
import warning from '../../assets/icons/warning.svg?no-inline';
import {Button} from '@chekin/guestapp-ui-kit';
import {
  Content,
  FailedModalButtonsContainer,
  ModalTwoButtons,
  ReasonItem,
  ReasonsBlock,
  StyledFailedModal,
  StyledLottie,
} from './styled';

const getIconProps = (isKiosko: boolean) => {
  const mainValue = isKiosko ? 90 : 50;
  return {width: mainValue, height: mainValue};
};

type IVProgressModalProps = ModalProps & {
  onTryAgain: () => void;
  docType: IV_DOCUMENT_IMAGE_TYPES;
  isRequired: boolean;
  layoutMode?: string;
  reasons?: string[];
  image?: string;
  onVerifyLater?: () => void;
};
function FailedModal({
  reasons,
  onTryAgain,
  image: _,
  onVerifyLater,
  layoutMode,
  isRequired,
  docType,
  ...props
}: IVProgressModalProps) {
  const {t} = useTranslation();

  const {animationData} = useFetchIVLottie({
    type: docType,
    isOCR: false,
  });

  return (
    <StyledFailedModal
      iconSrc={warning}
      iconProps={getIconProps(layoutMode === 'kiosko')}
      {...props}
      className="kiosko:max-h-[1300px]"
    >
      <Content className="kiosko:max-w-[600px]">
        <StyledLottie
          animationData={animationData}
          className="kiosko:max-w-[600px] kiosko:h-[400px]"
        />
        <FailedModalButtonsContainer>
          <ReasonsBlock>
            <ReasonItem className="kiosko:text-kiosko-s">
              {t('possible_reasons')}
            </ReasonItem>
            {reasons?.map(reason => (
              <ReasonItem key={reason}>
                <img src={notIncludedIcon} width={24} height={24} alt="" />
                <p className="kiosko:text-kiosko-xs">{reason}</p>
              </ReasonItem>
            ))}
          </ReasonsBlock>
          <ModalTwoButtons>
            <Button onClick={onTryAgain}>{t('try_again')}</Button>
            {!isRequired && <Button onClick={onVerifyLater}>{t('verify_later')}</Button>}
          </ModalTwoButtons>
        </FailedModalButtonsContainer>
      </Content>
    </StyledFailedModal>
  );
}

export {FailedModal};
